import { Component, OnInit, OnDestroy, NgZone } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterOutlet } from "@angular/router";
import { IonApp, IonRouterOutlet } from "@ionic/angular/standalone";
import { register } from "swiper/element/bundle";
import { environment } from "../environments/environment";
import { Hub } from "aws-amplify/utils";
import { Router } from "@angular/router";
import { showCompanyMessage } from "@avsit-io/avsit-logo";
import { IntlService, CldrIntlService } from "@progress/kendo-angular-intl";
import { UpdateService } from "./services/update.service";
import { LaunchDarklyService } from "./services/launch-darkly.service";
import { BusinessTokenService } from "./services/business-central/business-token.service";
import "aws-amplify/auth/enable-oauth-listener";
import {
  fetchAuthSession,
  getCurrentUser,
  updateUserAttributes,
} from "aws-amplify/auth";
import { generateClient } from "aws-amplify/api";
import { onUpdateMaintenance } from "src/graphql/subscriptions";
import { listMaintenances, userProfileByEmail } from "src/graphql/queries";
import { AuthService } from "./auth/auth.service";
import { profile } from "./API.service";
import { AlertInfoComponent } from "./maintenance/alert-info/alert-info.component";

register();

@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    styleUrls: ["app.component.scss"],
    standalone: true,
    imports: [
      CommonModule,
      IonApp,
      IonRouterOutlet,
      AlertInfoComponent
    ]
})
export class AppComponent implements OnInit, OnDestroy {
  authenticated: boolean = false;
  profileId?: string;
  userEmail?: string;
  alert: boolean = false;
  token: string = "";
  client = generateClient();
  constructor(
    private router: Router,
    private ngZone: NgZone,
    public intlService: IntlService,
    private updateService: UpdateService,
    private launchDarkly: LaunchDarklyService,
    private tokenService: BusinessTokenService
  ) {
    console.log(environment.appVersion);
  }

  async ngOnInit() {
    this.client.graphql({ query: onUpdateMaintenance }).subscribe(() => {
      this.maintenanceCheck();
    });
    this.maintenanceCheck();

    (<CldrIntlService>this.intlService).localeId = "en-US";
    showCompanyMessage();

    Hub.listen("auth", async (data) => {

      switch (data.payload.event) {
        case "signedIn":
          this.checkProfile();
          break;
        case "signInWithRedirect":
          getCurrentUser().then((user) => {
            if (user) {
              this.authenticated = true;
            }
          });
          this.checkProfile();
          break;
        case "signInWithRedirect_failure":
          this.router.navigate(["/login"]);
          break;
      }
    });
    // if (localStorage.getItem("companyId") === null) {
    //   this.tokenService.getCompanyId();
    // }
  }

  async maintenanceCheck() {
    try {
      // Fetch maintenance data
      const data = await this.client.graphql({ query: listMaintenances });
      // const data = await this.api.ListMaintenances();
      // Check if any item has status true
      this.alert = data.data.listMaintenances.items.some(
        (item) => item.status === true
      );

      const currentDate = new Date();
      const startedMaintenance = data.data.listMaintenances.items.find(
        (item) => {
          const startDate = new Date(item.startTime);
          return startDate <= currentDate;
        }
      );

      // Fetch the current session (not a user object)
      const session = await fetchAuthSession();
      const idTokenPayload = session.tokens?.idToken?.payload;


      const userEmail = idTokenPayload?.["email"] || "";

      // Ensure userEmail is of type string
      const userEmailString = typeof userEmail === "string" ? userEmail : "";

      // Navigate to maintenance page if maintenance started & user domain is not `avsit.io`
      if (startedMaintenance && startedMaintenance.status) {
        if (userEmailString.split("@")[1] !== "avsit.io") {
          this.router.navigate(["/maintenance"]);
        }
      }

    } catch (err) {
      console.error("Error fetching maintenance items:", err);
      this.alert = false;
    }
  }

  async checkProfile() {
    try {
      // Fetch the current session for token & payload data
      const session = await fetchAuthSession();
      const idTokenPayload = session.tokens?.idToken?.payload;

      if (!idTokenPayload) {
        console.error("No ID token payload found");
        return;
      }

      const userEmail =
        typeof idTokenPayload["email"] === "string"
          ? idTokenPayload["email"].toLowerCase()
          : "";
      const profileId = idTokenPayload["custom:profileId"];
      const privacyOptin = idTokenPayload["custom:privacyOptin"];
      const sub = idTokenPayload.sub;

      // console.log(`USER Session Payload: `, idTokenPayload);


      this.launchDarkly.updateUserContext("user", sub, userEmail);

      if (!profileId) {
        // No linked profile ID found
        const userProfiles = await this.client.graphql({
          query: userProfileByEmail,
          variables: { email: userEmail },
        });
        // const userProfiles = await this.api.UserProfileByEmail(userEmail);

        if (userProfiles.data.userProfileByEmail.items.length === 0) {
          // No user profile found for this email
          this.router.navigate(["/link-profile"]);
        } else {
          // We found a user profile for this email, let's link it
          const userId = userProfiles.data.userProfileByEmail.items[0]?.id;

          try {
            await updateUserAttributes({
              userAttributes: {
                "custom:profileId": userId,
              },
            });

            if (!privacyOptin) {
              this.router.navigate(["/onboarding"]);
            } else {
              this.ngZone.run(() => {
                this.router.navigate(["user/sales/list"]);
              });
            }
          } catch (err) {
            console.error(`Error updating user attributes:`, err);
          }
        }
      } else {
        // profileId already linked
        if (!privacyOptin) {
          this.router.navigate(["/onboarding"]);
        } else {
          this.ngZone.run(() => {
            this.router.navigate(["user/sales/list"]);
          });
        }
      }
    } catch (err) {
      console.error(`Error in checkProfile:`, err);
    }
  }

  ngOnDestroy(): void {
    this.launchDarkly.closeClient();
  }
}
